// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__2kJa0","content":"GlobalSearch_content__3cc4i"};